import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { NotificationEntity } from './notification.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk__notification__id', ['fkNotificationId'], {})
@Entity('_notification__file')
export class NotificationFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', nullable: true, unsigned: true })
	public fkFileId!: number | null;

	@Column('int', {
		name: '_fk__notification__id',
		nullable: true,
		unsigned: true,
	})
	public fkNotificationId!: number | null;

	@ManyToOne(() => FileEntity, (file) => file.notificationFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(
		() => NotificationEntity,
		(notification) => notification.notificationFiles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__notification__id', referencedColumnName: 'id' }])
	public fkNotification!: NotificationEntity;
}
